module.exports = __webpack_public_path__ + "static/media/004-ai.2b74c1ec.svg";